<template lang="pug">
  div.map-container.geo.map-objects
    div.toolbar
      div.line
        h1.title {{$translate('Карта')}}
        e-suggestion(
        placeholder=" "
        :suggestionEndpoint="suggestionEndpoint"
        :transformSuggestions="transformSuggestions"
        @selectItem="selectItemOnMapSearch"
        name="q"
        :model="suggestionMapSearch"
        :useInnerSearch="false"
        :addInfo="true"
        :addInfoField="'address'"
        :addBorder="true"
        ).search
    map-mapping-legend(
    :mappingCurrentLegend="mappingCurrentLegend"
    :legendItems="legendItems"
    )

    div.new-map
      div(ref="map" v-once).bigmap#map

      transition(name="fade")
        div.legend.legend--objects.cuscroll(:class="showMapLegend ? 'open' : 'close'")
          div(v-if="layersLoading").hover-on-loading
          e-perfect-scrollbar
            div.head(@click="showMapLegend = !showMapLegend")
              h2.title {{$translate('Слои')}}
              //span.toolbar-filter__close
              span.legend__close(v-if="showMapLegend")
              span.legend__open(v-else) 
            div(
              v-if="userData && userData.isAdmin"
            ).type-group.map-mapping-selector
              div.type
                label.checked
                  span
                  span.marker Кластеризация
                label.new-check
                  input.new-checkbox(type="checkbox" @change="toggleClusters" v-model="clusterEnabled")
                  span
            map-mapping-selector(
            :mappingConfObject="mappingConfObject"
            :selectedMappingObject="selectedMappingObject"
            @rosreestrChangeView="onRosreestrChangeView"
            @change="setSelectedMappingObject"
            @showEquidistant="onShowEquidistant"
            @setEquidistant="updateEquidistantCircle"
            )

            div.type-group.load
              div.type
                label.checked
                  span.marker {{$translate('Статус')}}
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span
              div.group
                el-tooltip(transition="none" effect="light" placement="left" :content="layers.length === 0 ? 'Выберите объекты' : 'Показать активные объекты'")
                  div.type.status-active
                    label.checked
                      input.checkbox(:disabled="layers.length === 0" type="checkbox" @change="showStatus" v-model="showedStatus" :value="1")
                      span
                      span.marker {{$translate('Действующий')}}
                el-tooltip(transition="none" effect="light" placement="left" :content="layers.length === 0 ? 'Выберите объекты' : 'Показать планируемые объекты'")
                  div.type.status-planned
                    label.checked
                      input.checkbox(:disabled="layers.length === 0" type="checkbox" @change="showStatus" v-model="showedStatus" :value="3")
                      span
                      span.marker {{$translate('Планируемый')}}

            div(v-for="item, name in layersConf" :class="'type-group ' + item.menuClass")
              div.type
                label.checked
                  input.checkbox(type="checkbox" @change="onLayersChange(item, name)" v-model="layers" :value="name")
                  span
                  span.marker {{$translate(item.label)}}
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span
              template(v-if="item.groups" v-for="groupItem, groupItemName in item.groups")
                div(v-if="groupItem && !groupItem.hideFromMenu").group
                  div(:class="'type ' + groupItem.menuClass")
                    label.checked
                      input.checkbox(type="checkbox" @change="onLayersChange(groupItem, groupItemName, name)" v-model="layers" :value="groupItemName")
                      span
                      span.marker {{$translate(groupItem.label)}}
    router-view
</template>

<script>
  import objectsMixin from '../mixins/objects-mixin'
  import {map as mapEndpoints} from '../../../api/api-endpoints.js'
  import mappingMixin from '../mixins/mapping-mixin'
  import MapMappingLegend from "../components/map-mapping-legend";
  import MapMappingSelector from "../components/map-mapping-selector";
  import { DEFAULT_OPACITY, FORMED_POPUP, POP_POPUP, VILLAGE_ZOOM_ARR, ZONES } from '../config/config'
  import {ProcessingId, ProcessingNoTkoId} from '../../../config/config';
  import { MAP } from '../../../config/map'


  export default {
    name: 'objects',
    components: {MapMappingSelector, MapMappingLegend},
    mixins: [objectsMixin, mappingMixin],
    computed: {
      mappingConfObject () {
        return {
          population: {
            title: 'Население',
            legends: [
              {
                endpoint: mapEndpoints.heatMapPopulationDistrict,
                valueKey: 'population',
                popup: POP_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                items: [
                  {title: '1-25 тыс.', min: 0, style: {color: '#fad089'}},
                  {title: '25-50 тыс.', min: 25000, style: {color: '#ff9c5b'}},
                  {title: '50-75 тыс.', min: 50000, style: {color: '#f5634a'}},
                  {title: '75-100 тыс.', min: 75000, style: {color: '#ed313c'}},
                  {title: 'от 100 тыс.', min: 100000, style: {color: '#a8016d'}}
                ]
              },
              {
                // hideLegend: true,
                showOnZoom: VILLAGE_ZOOM_ARR,
                valueKey: 'population',
                endpoint: mapEndpoints.heatMapPopulationSettlement,
                popup: POP_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                items: [
                  {title: '1-25 тыс.', min: 0, style: {fillColor: '#fad089', color: '#ff9c5b'}},
                  {title: '25-50 тыс.', min: 25000, style: {fillColor: '#ff9c5b', color: '#ff9c5b'}},
                  {title: '50-75 тыс.', min: 50000, style: {fillColor: '#f5634a', color: '#ff9c5b'}},
                  {title: '75-100 тыс.', min: 75000, style: {fillColor: '#ed313c', color: '#ff9c5b'}},
                  {title: 'от 100 тыс.', min: 100000, style: {fillColor: '#a8016d', color: '#ff9c5b'}}
                ]
              }
            ]
          },
          formed: {
            title: 'Количество образованных отходов',
            legends: [
              {
                endpoint: mapEndpoints.heatMapFormedDistrict,
                valueKey: 'formed',
                popup: FORMED_POPUP,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                items: [
                  {title: '1-25 тыс.', min: 0, style: {color: '#74db54'}},
                  {title: '25-50 тыс.', min: 25000, style: {color: '#bbe668'}},
                  {title: '50-100 тыс.', min: 50000, style: {color: '#f6e548'}},
                  {title: '100-250 тыс.', min: 100000, style: {color: '#ffc90e'}},
                  {title: 'от 250 тыс.', min: 250000, style: {color: '#ed313c'}}
                ]
              },
              {
                // hideLegend: true,
                showOnZoom: VILLAGE_ZOOM_ARR,
                style: {
                  opacity: DEFAULT_OPACITY
                },
                endpoint: mapEndpoints.heatMapFormedSettlement,
                valueKey: 'formed',
                popup: FORMED_POPUP,
                items: [
                  {title: '1-25 тыс.', min: 0, style: {color: '#74db54'}},
                  {title: '25-50 тыс.', min: 25000, style: {color: '#bbe668'}},
                  {title: '50-100 тыс.', min: 50000, style: {color: '#f6e548'}},
                  {title: '100-250 тыс.', min: 100000, style: {color: '#ffc90e'}},
                  {title: 'от 250 тыс.', min: 250000, style: {color: '#ed313c'}}
                ]
              }
            ]
          },
          [ZONES]: {
            title: 'Зоны деятельности региональных операторов',
            legends: [
              {
                endpoint: mapEndpoints.heatMapRegOperators(this.$route.query.zoom || MAP.zoom),
                popup: {
                  head: 'Зона действия',
                  fields: (this.$route.query.zoom && this.$route.query.zoom >= 10 || MAP.zoom >= 10) ? [
                    { value: 'apoName', label: 'Наименование' },
                    { value: 'village_settlement', label: 'Сельское поселение'},
                    { value: 'name_with_type', label: 'Район' },
                    { value: 'operatorName', label: 'Региональный оператор' },
                    { value: 'total_garbage', label: 'Количество образованных отходов, тонн' },
                    { value: 'total_garbage_cubic', label: 'Количество образованных отходов, м³' },
                    { value: 'total_garbage_processing', label: 'Количество переработанных отходов, тонн' },
                    { value: 'total_garbage_cubic_processing', label: 'Количество переработанных отходов, м³' },
                    { value: 'total_garbage_storage', label: 'Количество захороненных  отходов, тонн' },
                    { value: 'total_garbage_cubic_storage', label: 'Количество захороненных  отходов, м³' },
                    { value: 'apoTotalGarbageSum', label: 'Количество образованных отходов по всей зоне, тонн' },
                    { value: 'apoTotalGarbageCubicSum', label: 'Количество образованных отходов по всей зоне, м³' },
                    {
                      value: 'tariffLimitForecastValue',
                      label: 'Прогнозное значение предельного тарифа на текущий регулируемый период, руб'
                    },
                    {value: 'tariff_processing', label: 'Тариф на обработку ТКО'},
                    {value: 'tariff_neutralization', label: 'Тариф на обезвреживание ТКО'},
                    {value: 'tariff_burial', label: 'Тариф на захоронение ТКО'},
                    {value: 'tariff_collection', label: 'Собственные затраты регионального оператора'},
                    {value: 'tariff_transportation', label: 'Цена на транспортирование ТКО'},
                    {value: 'tariff_regop_common', label: 'Единый тариф на услугу Регионального оператора'},
                  ] : [
                    { value: 'apoName', label: 'Наименование' },
                    { value: 'name_with_type', label: 'Район' },
                    { value: 'operatorName', label: 'Региональный оператор' },
                    { value: 'total_garbage', label: 'Количество образованных отходов, тонн' },
                    { value: 'total_garbage_cubic', label: 'Количество образованных отходов, м³' },
                    { value: 'total_garbage_processing', label: 'Количество переработанных отходов, тонн' },
                    { value: 'total_garbage_cubic_processing', label: 'Количество переработанных отходов, м³' },
                    { value: 'total_garbage_storage', label: 'Количество захороненных  отходов, тонн' },
                    { value: 'total_garbage_cubic_storage', label: 'Количество захороненных  отходов, м³' },
                    { value: 'apoTotalGarbageSum', label: 'Количество образованных отходов по всей зоне, тонн' },
                    { value: 'apoTotalGarbageCubicSum', label: 'Количество образованных отходов по всей зоне, м³' },
                    {
                      value: 'tariffLimitForecastValue',
                      label: 'Прогнозное значение предельного тарифа на текущий регулируемый период, руб'
                    },
                    {value: 'tariff_processing', label: 'Тариф на обработку ТКО'},
                    {value: 'tariff_neutralization', label: 'Тариф на обезвреживание ТКО'},
                    {value: 'tariff_burial', label: 'Тариф на захоронение ТКО'},
                    {value: 'tariff_collection', label: 'Собственные затраты регионального оператора'},
                    {value: 'tariff_transportation', label: 'Цена на транспортирование ТКО'},
                    {value: 'tariff_regop_common', label: 'Единый тариф на услугу Регионального оператора'},
                  ]
                },
                valueKey: false,
                hideLegend: true,
                items: [
                  {min: 0}
                ]
              }
            ]
          }
        }
      },
    },
    methods: {
      getLayersConf () {
        return {
          gs: {
            menuClass: 'oth',
            label: 'Отходообразователи',
            endpoint: mapEndpoints.source,
            className: 'cluster-marker',
            iconType: 'wasteCreators',
            groups: {
              org: {
                menuClass: 'oth-hoz',
                iconType: 'org',
                label: 'Организация/ИП',
                restApiOrder: 2
              },
              med: {
                menuClass: 'oth-med',
                iconType: 'med',
                label: 'Медицинские учреждения',
                restApiOrder: 5
              },
              ind: {
                menuClass: 'oth-individ',
                iconType: 'ind',
                label: 'Индивидуальное домовладение',
                restApiOrder: 6
              },
              set: {
                menuClass: 'oth-village',
                iconType: 'set',
                label: 'Деревни, поселки, села',
                restApiOrder: 3
              },
              apartmentBuildings: {
                menuClass: 'oth-apartment-buildings',
                iconType: 'apartmentBuildings',
                label: 'Многоквартирные дома',
                restApiOrder: 9
              },
              dep: {
                menuClass: 'oth-garbage-deposits',
                iconType: 'deposits',
                label: 'Месторождения, лицензионные участки',
                restApiOrder: 10
              },
              fac: {
                menuClass: 'oth-garbage-factories',
                iconType: 'factories',
                label: 'Фактории',
                restApiOrder: 11
              },
              dor: {
                menuClass: 'oth-garbage-dormitories',
                iconType: 'dormitories',
                label: 'Общежития',
                restApiOrder: 12
              },
              pup: {
                menuClass: 'oth-garbage-factories',
                iconType: 'dormitories',
                label: 'Объекты общественного назначения',
                restApiOrder: 13
              },
            }
          },
          msn: {
            iconType: 'places',
            menuClass: 'places',
            label: 'Места сбора и накопления',
            endpoint: mapEndpoints.msn,
            className: 'cluster-marker msn',
            groups: {
              container: {
                menuClass: 'places-cont',
                iconType: 'container',
                label: 'Контейнерные площадки',
                restApiOrder: 1
              },
              noContainer: {
                menuClass: 'places-noCont',
                iconType: 'noContainer',
                label: 'Бесконтейнерный сбор',
                restApiOrder: 2
              },
              separate: {
                menuClass: 'places-points',
                iconType: 'separate',
                label: 'Пункты сбора вторсырья',
                restApiOrder: 3
              },
              planned: {
                menuClass: 'places-planned',
                iconType: 'container',
                label: 'Планируемые МСиН',
                restApiOrder: 4
              },
            }
          },
          dump: {
            iconType: 'svalka',
            menuClass: 'svalka',
            label: 'Несанкционированные свалки',
            endpoint: mapEndpoints.heap,
            className: 'cluster-marker heap',
            groups: {
              heap: {
                menuClass: 'svalka-thrash',
                iconType: 'thrash',
                label: 'Навалы мусора',
                restApiOrder: 1
              },
              unauth: {
                endpoint: mapEndpoints.object,
                menuClass: 'svalka-noThrash',
                iconType: 'noThrash',
                label: 'Несанкционированные ОРО',
                restApiOrder: 2
              }
            }
          },
          object: {
            iconType: 'garbage',
            menuClass: 'obj',
            label: 'Объекты обращения с отходами',
            endpoint: mapEndpoints.object,
            className: 'cluster-marker object',
            groups: {
              process: {
                menuClass: 'obj-obrab',
                iconType: 'process',
                label: 'Объекты обработки ТКО',
                restApiOrder: ProcessingId
              },
              process_notko: {
                menuClass: 'obj-obrab-notko',
                iconType: 'process-notko',
                label: 'Объекты обработки не ТКО',
                restApiOrder: ProcessingNoTkoId
              },
              util: {
                menuClass: 'obj-utiliz',
                iconType: 'util',
                label: 'Объекты утилизации',
                restApiOrder: 5
              },
              neutral: {
                menuClass: 'obj-obezvr',
                iconType: 'neutral',
                label: 'Объекты обезвреживания',
                restApiOrder: 3
              },
              storage: {
                menuClass: 'obj-chran',
                iconType: 'storage',
                label: 'Объекты хранения',
                restApiOrder: 4
              },
              burial: {
                menuClass: 'obj-zachoron',
                iconType: 'burial',
                label: 'Объекты захоронения',
                restApiOrder: 6
              }
            }
          },
          transport: {
            menuClass: 'transp',
            label: 'Транспортировщики',
            endpoint: mapEndpoints.transport,
            className: 'cluster-marker transport',
            iconType: 'transp',
            groups: {
              trans: {
                hideFromMenu: true,
                iconType: 'transport',
                label: 'Транспортировщики',
                restApiOrder: 1
              }
            }
          }
        }
      },
    }
  }
</script>
